import React from 'react';
import { FaSpinner } from 'react-icons/fa';

const LoadingPanel = ({ label }) => (
  <div className="flex min-h-[220px] items-center justify-center rounded-2xl border border-slate-200 bg-white">
    <div className="flex items-center gap-3 text-slate-600">
      <FaSpinner className="animate-spin" />
      <span className="text-sm font-medium">{label}</span>
    </div>
  </div>
);

export default LoadingPanel;
